/* Funpaper web globals — minimal reset, brand variables.
   Dark mode dimatikan (Fase 1 redesign): background selalu putih ala Notion,
   brand purple hanya aksen. */
:root {
  --color-primary: #563f7a;
  --color-primary-dark: #3d2c57;
  --color-background: #ffffff;
  --color-text: #201c23;
  --color-text-secondary: #6b6573;
  --color-accent: #ff8a3d;
  --font-display: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  background: var(--color-background);
  color: var(--color-text);
  font-family: var(--font-display);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
